import {
    SET_CAPACIDADE_OPTIONS,
    SET_OCUPACAO_CAPACIDADE,
    SET_CAPACIDADE_RECURSOS_CRITICOS,
    SET_OCUPACAO_CAPACIDADE_RECURSOS_CRITICOS,
    CLICK_CAPACIDADE_FILTER_CHECKBOX,
    CLICK_RECURSO_CRITICO_FILTER_CHECKBOX,
    ADD_CAPACIDADE_FABRICA,
    DEL_CAPACIDADE_FABRICA,
    CLEAN_CAPACIDADE_FABRICA,
    SET_SELECT_CAPACIDADE_ORCADA,
} from '../actions/actionTypes';

const initialState = {
    selectCapacidadeOrcada: true,
    capacidadeOptions: [],
    capacidadeRecursosCriticos: [],
    ocupacaoCapacidadeNos: {},
    ocupacaoCapacidadeRecursosCriticos: {},
    capacidadeFilterSelected: [],
    recursosCriticosFilterSelected: [],
    fabricasSelected: [],
};

export const optionsCapacidadeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECT_CAPACIDADE_ORCADA:
            return {
                ...state,
                selectCapacidadeOrcada: action.selectCapacidadeOrcada,
            };

        case SET_OCUPACAO_CAPACIDADE_RECURSOS_CRITICOS:
            return {
                ...state,
                ocupacaoCapacidadeRecursosCriticos: action.ocupacaoCapacidadeRecursosCriticos,
            };

        case SET_CAPACIDADE_RECURSOS_CRITICOS:
            return {
                ...state,
                capacidadeRecursosCriticos: action.capacidadeRecursosCriticos,
            };

        case SET_CAPACIDADE_OPTIONS:
            return {
                ...state,
                capacidadeOptions: action.capacidadeOptions,
            };

        case SET_OCUPACAO_CAPACIDADE:
            return {
                ...state,
                ocupacaoCapacidadeNos: action.ocupacaoCapacidadeNos,
            };

        case ADD_CAPACIDADE_FABRICA:
            const selecionarNos = state.capacidadeOptions
                .filter((e) => e.no !== null && e.fabrica === action.fabrica)
                .map((e) => `${e.fabrica}-${e.no}`);
            return {
                ...state,
                fabricasSelected: [...state.fabricasSelected, action.fabrica],
                capacidadeFilterSelected: [...new Set([...state.capacidadeFilterSelected, ...selecionarNos])],
            };

        case DEL_CAPACIDADE_FABRICA:
            const v1 = [...state.fabricasSelected];
            const removerNos = [...state.capacidadeFilterSelected].filter((e) => !e.startsWith(action.fabrica));
            v1.splice(v1.indexOf(action.fabrica), 1);
            return {
                ...state,
                fabricasSelected: v1,
                capacidadeFilterSelected: removerNos,
            };

        case CLEAN_CAPACIDADE_FABRICA:
            return {
                ...state,
                capacidadeFilterSelected: [],
                recursosCriticosFilterSelected: [],
                fabricasSelected: [],
            };

        case CLICK_CAPACIDADE_FILTER_CHECKBOX:
            var fabricasSelected = [...state.fabricasSelected];
            const v2 = [...state.capacidadeFilterSelected];
            if (!action.isAdd && v2.indexOf(action.capacidadeFilterSelected) >= 0) {
                v2.splice(v2.indexOf(action.capacidadeFilterSelected), 1);
                const fabrica = action.capacidadeFilterSelected.substr(0, 2);
                fabricasSelected.splice(fabricasSelected.indexOf(fabrica));
            } else {
                v2.push(action.capacidadeFilterSelected);
            }
            return {
                ...state,
                capacidadeFilterSelected: v2,
                fabricasSelected,
            };

        case CLICK_RECURSO_CRITICO_FILTER_CHECKBOX:
            const v3 = [...state.recursosCriticosFilterSelected];
            const index = v3.findIndex((x) => x.checkboxName === action.recursoCriticoFilterSelected.checkboxName);
            if (!action.isAdd && index >= 0) {
                v3.splice(index, 1);
            } else {
                v3.push(action.recursoCriticoFilterSelected);
            }
            return {
                ...state,
                recursosCriticosFilterSelected: v3,
            };

        default:
            return state;
    }
};
